const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-7 py-3.5 text-base font-medium hover:bg-[#e8463c] transition-colors";
const btnSecondary =
  "inline-flex items-center justify-center gap-2 border-2 border-[#1C1917] text-[#1C1917] rounded-[8px] px-7 py-3.5 text-base font-medium hover:bg-[#1C1917] hover:text-white transition-colors";

const GROUP_INCLUDES = [
  "Weekly coaching on a set day",
  "The complete Believing Happy experience",
  "3 months of Spark Sessions for protected time to put the work into action",
];

const PRIVATE_INCLUDES = [
  "Weekly private coaching on the day you choose",
  "The complete Believing Happy experience personalized around your life",
  "6 months of Spark Sessions for continued action and momentum",
];

export function GroupVsPrivate() {
  return (
    <section
      data-testid="believing-happy-groupvsprivate-section"
      className="relative bg-[#FAFAF8]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-24 md:py-28">

        {/* Dominant statement */}
        <div className="text-center max-w-2xl mx-auto reveal">
          <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
            Believing Happy
          </p>
          <h2
            data-testid="believing-happy-groupvsprivate-headline"
            className="font-display text-[38px] sm:text-[50px] lg:text-[58px] leading-[1.08] tracking-tight text-[#1C1917]"
          >
            Ten weeks. Done your way.
          </h2>
          <div className="mt-6 space-y-3 text-lg md:text-xl leading-relaxed text-[#57534E]">
            <p>
              Believing Happy is a ten-week coaching experience grounded in
              the Blueprint4Joy&reg; Method.
            </p>
            <p>
              We&rsquo;ll get clear about what&rsquo;s true now, reconnect
              with what you actually want and turn that clarity into
              momentum toward the dreams and changes that matter to you.
            </p>
            <p className="text-[#1C1917]">Then choose how you want to do the work.</p>
          </div>
        </div>

        {/* Comparison — two balanced editorial columns, divided by a thin line */}
        <div className="mt-16 md:mt-20 grid grid-cols-1 lg:grid-cols-2 gap-y-14 lg:gap-x-16 lg:divide-x lg:divide-[#E8E6E3]">

          {/* Group Experience */}
          <div className="lg:pr-16 reveal">
            <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-4">
              Group Experience
            </p>
            <h3 className="font-display text-[26px] sm:text-[30px] leading-[1.2] tracking-tight text-[#1C1917]">
              Clarity, momentum and the energy of doing it together.
            </h3>
            <p className="mt-4 text-lg leading-relaxed text-[#57534E]">
              Ten weeks of live Believing Happy coaching with a small group,
              following the Blueprint4Joy&reg; Method from honest
              reflection into meaningful action.
            </p>

            <div className="mt-8 space-y-4">
              {GROUP_INCLUDES.map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <span className="mt-[10px] w-1.5 h-1.5 rounded-full bg-[#159E9A] shrink-0" />
                  <p className="text-lg leading-relaxed text-[#57534E]">{item}</p>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <p className="text-xs tracking-[0.24em] uppercase text-[#8A8580] mb-2">
                Investment
              </p>
              <p
                data-testid="believing-happy-group-price"
                className="font-display text-[32px] text-[#1C1917]"
              >
                $800
              </p>
            </div>

            <button
              type="button"
              data-testid="believing-happy-group-cta"
              className={`${btnPrimary} mt-7 w-full sm:w-auto`}
            >
              Join the Group Experience
            </button>
          </div>

          {/* Private Coaching */}
          <div className="lg:pl-16 reveal">
            <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-4">
              Private Coaching
            </p>
            <h3 className="font-display text-[26px] sm:text-[30px] leading-[1.2] tracking-tight text-[#1C1917]">
              The same framework. More room for you.
            </h3>
            <p className="mt-4 text-lg leading-relaxed text-[#57534E]">
              Ten weeks of private Believing Happy coaching, with the
              flexibility to follow your questions, decisions and dreams
              more deeply as they emerge.
            </p>

            <div className="mt-8 space-y-4">
              {PRIVATE_INCLUDES.map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <span className="mt-[10px] w-1.5 h-1.5 rounded-full bg-[#159E9A] shrink-0" />
                  <p className="text-lg leading-relaxed text-[#57534E]">{item}</p>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <p className="text-xs tracking-[0.24em] uppercase text-[#8A8580] mb-2">
                Investment
              </p>
              <p
                data-testid="believing-happy-private-price"
                className="font-display text-[32px] text-[#1C1917]"
              >
                $2,400
              </p>
            </div>

            <button
              type="button"
              data-testid="believing-happy-private-cta"
              className={`${btnSecondary} mt-7 w-full sm:w-auto`}
            >
              Begin Private Coaching
            </button>
          </div>

        </div>
      </div>
    </section>
  );
}
